// import { NetworkType, PublicAccount } from 'nem2-sdk';
import { Component, Mixins } from 'vue-property-decorator';
import AssetMixin from './AssetMixin';

// You can declare a mixin as the same style as components.
@Component
export default class VerifyMixin extends Mixins(AssetMixin) {
    public async verify(publicKey: string): Promise<boolean> {
        // create a public account from public key
        const publicAccount = {};

        // initialize apostille http
        const filteredAssets = await this.filterAssets([publicAccount]);
        if (filteredAssets.length) {
          // asset has creation message
          // const transactions = filteredAssets[0].transactions;
          // const creationTX = transactions[transactions.length - 1];
          // TODO: verify the first transaction if it comes from specific manufacturer

          // then store the asset if valid
          this.storeAssetsInfo(filteredAssets);

          return true;
        } else {
          // asset doesn't has creation message
          return false;
        }
    }

    // public async verify(publicKey: string): Promise<Transaction | undefined> {
    //     // create a public account from public key
    //     const publicAccount = PublicAccount.createFromPublicKey(publicKey, NetworkType.MIJIN_TEST);

    //     // initialize apostille http
    //     const filteredAssets = await this.filterAssets([publicAccount]);
    //     if (filteredAssets.length) {
    //       // asset has creation message
    //       const transactions = filteredAssets[0].transactions;
    //       const creationTX = transactions[transactions.length - 1];
    //       // TODO: verify the first transaction if it cames from specific manufacturer

    //       // then store the asset if valid
    //       this.storeAssetsInfo(filteredAssets);

    //       // return creationTransaction
    //       return creationTX;
    //     } else {
    //       // asset doesn't has creation message
    //       return undefined;
    //     }
    // }
}
